exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3bVOW{background:-webkit-gradient(linear,left bottom,left top,from(rgba(253,191,0,.2)),to(rgba(253,191,0,.2))),#fff;background:-o-linear-gradient(bottom,rgba(253,191,0,.2),rgba(253,191,0,.2)),#fff;background:linear-gradient(0deg,rgba(253,191,0,.2),rgba(253,191,0,.2)),#fff;border:1px solid #ffd906;border-radius:5px;padding:20px}._3bVOW,.CHbsy{margin-bottom:15px}.CHbsy{font-weight:600;font-size:20px;line-height:120%;color:#000}", ""]);

// exports
exports.locals = {
	"root": "_3bVOW",
	"title": "CHbsy"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/SearchBarV2/SearchBarV2.css
// module id = 2425
// module chunks = 20 33